import React, { useEffect, useState } from 'react';
import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';

const header_links = [
  {
    label: 'Servicios',
    url: '',
    active: false,
    id: 1,
    sublinks: [
      {
        id: 1,

        label: 'Traslado de pasajeros',
        url: '/special-service',
      },
      {
        id: 1,

        label: 'Servicios de carga',
        url: '/cargo',
      },
      {
        id: 1,

        label: 'Precios y servicios',
        url: '/prices-and-services',
      },
    ],
  },
  {
    label: 'Destino',
    active: false,
    url: '/',
    id: 2,
  },
  {
    label: '¿Quiénes somos?',
    url: '',
    active: false,
    id: 3,

    sublinks: [
      {
        id: 3,

        label: 'Visión',
        url: '/about-us',
      },
      {
        id: 3,

        label: 'Misión',
        url: '/about-us',
      },
      {
        id: 3,

        label: 'Historia',
        url: '/about-us',
      },
      {
        id: 3,

        label: 'Nuestro equipo',
        url: '/about-us',
      },
    ],
  },
  {
    label: 'Viajero frecuente',
    url: '',
    active: false,
    id: 4,

    sublinks: [
      {
        id: 4,

        label: 'Tarjeta de viajero frecuente',
        url: '/frequent-card',
      },
      {
        id: 4,

        label: 'Términos y condiciones',
        url: '/terms-conditions',
      },
    ],
  },
  {
    label: 'Galería',
    active: false,

    id: 5,
    url: '/gallery',
  },
  {
    label: 'Nuestras empresas',
    active: false,
    id: 6,

    url: '/company',
  },
  {
    id: 7,
    label: 'Contacto',
    active: false,
    url: '/contact',
  },
];

const ThemeSevenHeader = ({ history, operator, onMyAccountClick, loginData, t }) => {
  const [state, setState] = useState(header_links);

  const getId = () => {
    const url = window.location.pathname;
    let id;
    if (url === '/') {
      return (id = 0);
    }
    if (url === '/special-service' || url === '/cargo' || url === '/prices-and-services') {
      return (id = 1);
    }
    if (url === '/about-us') {
      return (id = 3);
    }
    if (url === '/frequent-card' || url === '/terms-conditions') {
      return (id = 4);
    }
    if (url === '/gallery') {
      return (id = 5);
    }
    if (url === '/company') {
      return (id = 6);
    }
    if (url === '/contact') {
      return (id = 7);
    }
  };

  useEffect(() => {
    console.log('===id', getId());
    handleNavigation(getId());
  }, []);

  const handleNavigation = id => {
    const newHeader_links = state.map(item => {
      item.active = item.id === id ? true : false;
      return item;
    });
    setState(newHeader_links);
  };
  return (
    operator && (
      <div className="themes-theme-seven-header ">
        <div className="logo_navbar">
          <div className="logo new-container">
            <a href="/">
              <img
                src={operator && operator.header_logo}
                alt=""
                style={{
                  width: operator.header_logo_width ? operator.header_logo_width : '',
                  height: 'auto',
                }}
              />
            </a>
          </div>
        </div>
        <style>
          .nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
          margin-top:270px;
          {'}'}
          .nav-section.home-nav-section.common-top-strip.header-box.payments-page-header + * {'{'}
          margin-top:170px !important;
          {'}'}
        </style>
        <div className="nav ">
          <div className="nav-wrapper new-container">
            {state.map((val, i) => {
              return (
                <div
                  className={`nav-item ${val.active ? 'active' : ''}`}
                  onClick={() => {
                    val.url && handleNavigation(val.id);
                    val.url && history.push(val.url);
                  }}
                  key={i}
                >
                  {val.label}

                  {val.sublinks && (
                    <div className="sub-nav">
                      {val.sublinks &&
                        val.sublinks.map((sub, i) => {
                          return (
                            <div
                              className="sub-nav-item"
                              onClick={() => {
                                console.log('sub', sub);
                                handleNavigation(sub.id);
                                sub.url && history.push(sub.url);
                              }}
                              key={i}
                            >
                              {sub.label}
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              );
            })}

            {operator && operator.has_user_account && (
              <ul
              style={{marginLeft:20}}
              // className="header-login-icon-container"
              >
                <li>
                  <div className="my-account-top font10">
                    <a onClick={onMyAccountClick}>
                      {CommonService.isLoggedIn(loginData) && loginData.image_link ? (
                        <div className="dp-image-top">
                          <img src={loginData.image_link} alt="DIS" />
                        </div>
                      ) : (
                        <div
                          className={
                            'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
                          }
                        >
                          <img
                            src={getIcons('userIcon', operator)}
                            // src="/static/images/user_red_dot.svg"
                            alt={t('TRANSLATIONS.USER_DOT')}
                          />
                        </div>
                      )}
                      {/* {CommonService.isLoggedIn(this.props.common.loginData)
                          ? CommonService.capitalize(this.props.common.loginData.name)
                          : t('HOME.MY_ACCOUNT')} */}
                    </a>
                    {/* {this.state.showMyAccountDropDown ? this.renderMyAccountDropdown(t) : null} */}
                  </div>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ThemeSevenHeader;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/common/ThemeSevenHeader.js